import React from 'react';

const SvgSmartphoneHome = (props: any) => (
<svg version="1.1" id="Calque_1" x="0px" y="0px" viewBox="0 0 25 25" {...props}>
<g>
	<g>
		<g>
			<path fill={props.fill} d="M15.81,4.48L9.24,4.46c-1.01,0-1.83,0.81-1.83,1.82l0,1.1l-0.03,9.49l-0.01,1.83c0,1.01,0.81,1.83,1.82,1.83
				l6.57,0.02c1.01,0,1.83-0.81,1.83-1.82l0.01-1.83l0.03-9.49l0-1.1C17.63,5.3,16.82,4.48,15.81,4.48z M16.86,18.72
				c0,0.6-0.49,1.09-1.1,1.09l-6.57-0.02c-0.6,0-1.09-0.49-1.09-1.1l0-1.46l8.76,0.03L16.86,18.72z M16.87,16.53L8.11,16.5
				l0.03-8.76l8.76,0.03L16.87,16.53z M16.9,7.04L8.14,7.01l0-0.73c0-0.6,0.49-1.09,1.1-1.09l6.57,0.02c0.6,0,1.09,0.49,1.09,1.1
				L16.9,7.04z"/>
		</g>
	</g>
	<g>
		<g>
			<circle fill={props.fill} cx="12.66" cy="18.52" r="0.55"/>
		</g>
	</g>
</g>
</svg>
);

export default SvgSmartphoneHome;
